<template>
  <a-form-item :label="label" :name="name">
    <template v-if="type == 'textarea'">
      <a-textarea
        :placeholder="holder"
        v-model:value="inputValue"
        :rows="rows"
        autocomplete="off"
        :disabled="disabled"
      />
    </template>
    <a-input
      v-else
      :maxlength="maxlength"
      :placeholder="holder"
      v-model:value="inputValue"
      :allowClear="true"
      :disabled="disabled"
      autocomplete="off"
    />
  </a-form-item>
</template>
<script>
import { computed, reactive, toRefs, watch } from 'vue'
export default {
  props: {
    value: [String, Number]
  },
  setup(props, context) {
    const { emit, attrs } = context
    const state = reactive({
      ...attrs,
      ...{
        inputValue: props.value
      }
    })
    watch(
      () => state.inputValue,
      val => {
        emit('update:value', val)
      }
    )
    const holder = computed(() => {
      if (attrs.placeholder) {
        return attrs.placeholder
      }

      return attrs.disabled !== undefined ? '' : '请输入'
    })

    return {
      holder,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped></style>
